export enum CustomError {
  RECAPTCHA_GENERIC = "RecaptchaError",
  RECAPTCHA_NOT_ENOUGH_SCORES = "RecaptchaNotEnoughScoresError",
}
